export default "__VITE_ASSET__D3rjY3yq__"